/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectReport = {
    ReportingOverview: 'ReportingOverview',
    ReportingDaily: 'ReportingDaily',
    ReportingPeriodComparison: 'ReportingPeriodComparison',
    ReportingOrders: 'ReportingOrders',
    ReportingMarketing: 'ReportingMarketing',
    ReportingMarketingTrends: 'ReportingMarketingTrends',
    ReportingPno: 'ReportingPno',
    ReportingCampaigns: 'ReportingCampaigns',
    ReportingProducts: 'ReportingProducts',
    ReportingAbc: 'ReportingAbc',
    ReportingProductProfitability: 'ReportingProductProfitability',
    ReportingProfitability: 'ReportingProfitability',
    ReportingDiscounts: 'ReportingDiscounts',
    ReportingDeliveryPayments: 'ReportingDeliveryPayments',
    ReportingDomains: 'ReportingDomains',
    ReportingCentres: 'ReportingCentres',
    ReportingOtherCosts: 'ReportingOtherCosts'
} as const;
export type ProjectReport = typeof ProjectReport[keyof typeof ProjectReport];


export function instanceOfProjectReport(value: any): boolean {
    for (const key in ProjectReport) {
        if (Object.prototype.hasOwnProperty.call(ProjectReport, key)) {
            if (ProjectReport[key as keyof typeof ProjectReport] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectReportFromJSON(json: any): ProjectReport {
    return ProjectReportFromJSONTyped(json, false);
}

export function ProjectReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectReport {
    return json as ProjectReport;
}

export function ProjectReportToJSON(value?: ProjectReport | null): any {
    return value as any;
}

export function ProjectReportToJSONTyped(value: any, ignoreDiscriminator: boolean): ProjectReport {
    return value as ProjectReport;
}

